import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MainButton from "../../components/common/MainButton/MainButton";
import RatingStars from "../../components/common/RatingStars/RatingStars";
import useAuth from "../../Hooks/useAuth";
// import { useServiceReviews } from "../../Hooks/useServices";
import Certifications from "./Certifications";
import Associations from "./Associations";
import Social from "./Social";
import Payment from "./Payment";
import TradingHours from "./TradingHours";
import BusinessContact from "./BusinessContact";
import ServicesTags from "./ServicesTags";
import PosterReviews from "./PosterReviews";
import UserGigs from "./UserGigs";
import UserDescription from "./UserDescription";
import Portfolios from "../Portfolio/Portfolios";
import Popup from "../../components/popup/Popup";
import PostReportForm from "../../components/common/PostReportForm/PostReportForm";
import SharePopup from "../../components/common/SharePopup/SharePopup";
// import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import ProfileComponent from "../../components/common/Profile/ProfileComponent";
// import Heading from "../../components/common/Typography/Heading";
import PosterRanking from "./PosterRanking";
import ServiceHighlights from "./ServiceHighlights";
import FAQs from "./FAQs";
import Title from "../../components/common/Title/Title";
import QoutingForms from "../ServiceDetails/QouteForms/QoutingForms";
import Popups from "../../components/popup/Popups";
import SpecialText from "../../components/common/Typography/SpecialText";
import Tabs from '../../components/common/Tabs';
import ReviewCard from "../../components/common/ReviewCard/Card";
import ReviewSubmissionForm from "../../components/common/ReviewForm/ReviewSubmissionForm";
import photos from "../Portfolio/photos";
import Paragraph from "../../components/common/Typography/Paragraph";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import { BusinessInfo } from './BusinessInfo';
import { Badges } from './Badges';
import FullLengthSlider from '../AllServicesSlider/FullLengthSlider';
import { GetUserDetails } from '../../services/UserService';
import { useGraphQL } from "../../context/GraphQLProvider";
import InquiryForm from "../../components/InquiryForm/InquiryForm";
import Login from "../Login/Login";
import { SignUp } from "../SignUp/SignUp";
import { useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import { useLoginActionService, LOGIN_SCENARIOS } from '../../services/LoginActionService';
import KeywordsPopup from "./KeywordsPopup";
import ServiceAreas from "./ServiceAreas";
import Specialities from "./Specialities";
import Keywords from "./Keywords";
import Biography from "./Biography";
import ProfileStats from "./ProfileStats";
import { validateFile, getAcceptAttribute } from "../../utils/contentSafety";
import Alerts from "../../components/common/Alerts/Alerts";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_PROFILE_REVIEW_STATS_TO_LIST_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ProfileMainContainer = () =>
  // {
  // data,
  // ListingId,
  // AuthnicateData,
  // listRating,
  // tagsList,
  // showMeReply,
  // }
  {
    const [report, setReport] = useState(false);
    const [ShowCrossButton, setShowCrossButton] = useState(true);
    const [qouting, setQouting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [starFilter, setStarFilter] = useState(null);
      const [inquiryOpen, setInquiryOpen] = useState(false);
        const [inquiryAction, setInquiryAction] = useState('profile');
  const [inquiryData, setInquiryData] = useState(null);
  const posterRankingRef = useRef(null);
  const [SignUpState, setSignUpState] = React.useState(false);
  const [SignIn, setSignIn] = React.useState(false);
  const [sharePopupOpen, setSharePopupOpen] = useState(false);
  const [shareReviewPopupOpen, setShareReviewPopupOpen] = useState(false);
  const [keywordsPopupOpen, setKeywordsPopupOpen] = useState(false);
  const reviewsSectionRef = useRef(null);
  const [pendingInquiry, setPendingInquiry] = useState(false);
  const loginActionService = useLoginActionService();

  // Function to open inquiry form with specific action and data
  const openInquiryForm = (action, data) => {
    setInquiryAction(action);
    setInquiryData(data);
    setInquiryOpen(true);
  };

  // Function to open profile report form
  const openProfileReportForm = () => {
    setReport(true);
  };

  // Function to open review form
  const openReviewForm = () => {
    // This will be called by PosterRanking component after login
    // We need to trigger the review form opening in PosterRanking
    // For now, we'll use a ref or callback approach
  };

    const handleFileInputChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const result = validateFile(file, "image");
      if (!result.valid) {
        Alerts.error(result.message);
        e.target.value = "";
        return;
      }
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      e.target.value = "";
    };
    // const getReactionInfo = AuthnicateData?.data?.$values.find(
    //   (e) => e.id?.toString() === ListingId.toString()
    // );
    // const listingInfo = data;
    // const [heartClick, setheartClick] = useState(getReactionInfo?.listReaction);
    // const [SignUpState, setSignUpState] = React.useState(false);
    // const [SignIn, setSignIn] = React.useState(false);
    // const ListImage = JSON?.parse(listingInfo.pictures);
    // const Images = ListImage?.map((e) => {
    //   return { original: e, thumbnail: e };
    // });
    // const { data: reviewsData, status } = useServiceReviews(ListingId);
    // const [ReviewsList, setReviewsList] = useState();
    // useEffect(() => {
    //   const sortOrderByDescbyRating = (List) => {
    //     let sortedDsc = List?.sort((a, b) => {
    //       return parseInt(b.starRating) - parseInt(a.starRating);
    //     });
    //     return sortedDsc;
    //   };
    //   setReviewsList(sortOrderByDescbyRating(reviewsData?.data?.key?.$values));
    // }, [ListingId, reviewsData]);

    // const ReviewHandler = () => {
    //   if (!auth?.user) {
    //     setSignIn(true);
    //   } else {
    //     navigate({
    //       pathname: "/WriteReview/",
    //       search: `?${createSearchParams({
    //         id: ListingId,
    //       })}`,
    //     });
    //   }
    // };
    const navigate = useNavigate();
    const { auth } = useAuth();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userIdFromUrl = params.get("id");
    const tabFromUrl = params.get("tab");
    const userId = userIdFromUrl || auth?.user?.id?.toString?.();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const graphqlService = useGraphQL();
    const dispatch = useDispatch();

    useEffect(() => {
      const fetchUser = async () => {
        if (!userId) return;
        setLoading(true);
        try {
          const response = await GetUserDetails(graphqlService, { userId: Number(userId) });
          let fetchedUserData = response?.getUserDetails || null;
          
          // Set default plan if userPlan is null: Basic for userId 95, Pro for all others
          if (fetchedUserData && !fetchedUserData.userPlan) {
            const isBasicUser = Number(userId) === 95;
            fetchedUserData = {
              ...fetchedUserData,
              userPlan: {
                id: 1,
                userId: Number(userId),
                planId: isBasicUser ? 1 : 2,
                isTrialActive: false,
                isPaidActive: true,
                plan: {
                  name: isBasicUser ? 'Basic' : 'Pro'
                }
              }
            };
          }
          
          setUserData(fetchedUserData);
        } catch (e) {
          setUserData(null);
        } finally {
          setLoading(false);
        }
      };
      if (userId) {
        fetchUser();
      }
    }, [userId, graphqlService]);

    console.log(userData);
    console.log(auth);
    // Handle tab parameter from URL
    useEffect(() => {
      if (tabFromUrl === "reviews") {
        setActiveTab(2); // Reviews tab index
        setTimeout(() => {
          if (reviewsSectionRef.current) {
            reviewsSectionRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }, 300); // Wait for tab to render
      }
    }, [tabFromUrl]);

    // Handle automatic inquiry form opening after login redirect
    useEffect(() => {
      if (auth?.user && pendingInquiry) {
        setInquiryOpen(true);
        setPendingInquiry(false);
      }
    }, [auth?.user, pendingInquiry]);

    const ReviewItems = [
      {
        text: "Communication",
      },
      {
        text: "Reliability",
      },
      {
        text: "Satisfaction",
      },
      {
        text: "Recommend",
      },
      {
        text: "Punctuality",
      },
    ];
    useEffect(() => {
      if (report || qouting || inquiryOpen || SignIn || SignUpState || sharePopupOpen || shareReviewPopupOpen || keywordsPopupOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "visible";
        document.body.style.width = `auto`;
      }
    }, [report, qouting, inquiryOpen, SignIn, SignUpState, sharePopupOpen, shareReviewPopupOpen, keywordsPopupOpen]);

    // Handle share button click
    const handleShareClick = () => {
      setSharePopupOpen(true);
    };

    const isOwnProfile =
      auth?.user && userIdFromUrl && String(auth.user.id) === String(userIdFromUrl);
    const showFollowButton =
      userData?.userPlan?.plan?.name?.toLowerCase() !== "basic" && !isOwnProfile;

    const isCustomer = userData?.roleType?.toLowerCase() === "customer";
    const profileDisplayName = isCustomer
      ? `${userData?.firstName || ""} ${userData?.lastName || ""}`.trim() || "User Name"
      : userData?.businessName || "Business Name";

    // Handle share review link click
    const handleShareReviewClick = () => {
      setShareReviewPopupOpen(true);
    };

    // Generate the profile share URL
    const profileShareUrl = `${window.location.origin}/poster-profile/?id=${userId}`;
    
    // Generate the review share URL
    const reviewShareUrl = `${window.location.origin}/poster-profile/?id=${userId}&tab=reviews`;

    return (
        <>
          {SignIn && (
            <Login
              location={location.pathname + location.search}
              SignIn={SignIn}
              setSignIn={setSignIn}
              SignUpState={SignUpState}
              setSignUpState={setSignUpState}
              onLoginSuccess={() => {
                console.log('onLoginSuccess called in ProfileMainContainer component');
                
                // Create a function that can handle different popup types based on the scenario
                const handlePopupOpen = (popupType, data) => {
                  switch (popupType) {
                    case 'inquiry_form':
                      if (data && data.action) {
                        const inquiryData = data.action === 'post' ? data.postData : data.profileData;
                        openInquiryForm(data.action, inquiryData);
                      } else {
                        openInquiryForm('profile', userData);
                      }
                      break;
                    case 'quote_request_form':
                      // This would be handled by Header component
                      break;
                    case 'post_report_form':
                      // This would be handled by ServiceDetailsContainer
                      break;
                    case 'profile_report_form':
                      openProfileReportForm();
                      break;
                    case 'review_form':
                      // Trigger review form opening in PosterRanking component
                      if (posterRankingRef.current && posterRankingRef.current.openReviewForm) {
                        posterRankingRef.current.openReviewForm();
                      }
                      break;
                    default:
                      console.log('Unknown popup type:', popupType);
                  }
                };

                // Check for pending scenarios after login
                const hasPendingScenario = loginActionService.checkAndHandlePendingScenario(handlePopupOpen);

                // Close login modal after handling pending scenario to prevent blink
                if (hasPendingScenario) {
                  // If there's a pending scenario, close login modal after opening the popup
                  setTimeout(() => {
                    setSignIn(false);
                  }, 150); // Delay to ensure popup opens first, then login modal closes
                } else {
                  // If no pending scenario, close login modal immediately
                  setSignIn(false);
                }
              }}
            />
          )}
          {SignUpState && (
            <SignUp
              location={location.pathname + location.search}
              SignUpState={SignUpState}
              setSignUpState={setSignUpState}
              SignIn={SignIn}
              setSignIn={setSignIn}
            />
          )}
          {/* Inquiry Form Popup */}
          <InquiryForm
            isOpen={inquiryOpen}
            onClose={() => setInquiryOpen(false)}
            action={inquiryAction}
            postData={inquiryAction === 'post' ? inquiryData : null}
            profileData={inquiryAction === 'profile' ? inquiryData : null}
          />
          {/* Share Popup */}
          <SharePopup
            isOpen={sharePopupOpen}
            onClose={() => setSharePopupOpen(false)}
            postTitle={userData?.businessName || userData?.firstName + " " + userData?.lastName || "Profile"}
            currentUrl={profileShareUrl}
            shareType="profile"
          />
          
          {/* Share Review Popup */}
          <SharePopup
            isOpen={shareReviewPopupOpen}
            onClose={() => setShareReviewPopupOpen(false)}
            postTitle={userData?.businessName || userData?.firstName + " " + userData?.lastName || "Profile"}
            currentUrl={reviewShareUrl}
            shareType="reviews"
          />
          
          {/* Keywords Popup */}
          <KeywordsPopup
            isOpen={keywordsPopupOpen}
            onClose={() => setKeywordsPopupOpen(false)}
            userData={userData}
          />
        
        <div className={`tp-container mx-auto ${publicMainHeaderOffsetClass()}`}>
          <div className="flex flex-col md:flex-row gap-6 items-start">
            {/* Left Side - Profile Component */}
            <div className="w-full md:w-1/2 order-2 md:order-1">
              <ProfileComponent
                minimal={true}
                hideDisplayName
                reporting={() => {
                  loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.PROFILE_REPORT.id, {
                    setSignIn,
                    currentPath: location.pathname + location.search,
                    auth,
                    setPopupOpen: openProfileReportForm,
                    popupData: { profileData: userData }
                  });
                }}
                actions={true}
                heading={"ABC Company PVT LTD"}
                userData={userData}
              />
              {userData && (
                <div className="mt-5 ml-1 max-w-[30rem]">
                  <SpecialText variant="ProfilePrimary" className="text-offblack capitalize">
                    {profileDisplayName}
                  </SpecialText>
                </div>
              )}
              {/* Post Report Form */}
              <PostReportForm
                isOpen={report}
                onClose={() => setReport(false)}
                postData={userData}
                reportType="profile"
              />
              <div className="mt-5 flex items-center gap-3">
                <MainButton
                  variant={"medium"}
                  type="button"
                  onClick={() => {
                    loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.PROFILE_GET_IN_TOUCH.id, {
                      setSignIn,
                      currentPath: location.pathname + location.search,
                      auth,
                      setPopupOpen: setInquiryOpen,
                      popupData: { postData: userData }
                    });
                  }}
                >
                  Get in Touch
                </MainButton>
                {showFollowButton && (
                  <MainButton variant="outlinesmall" type="button">
                    Follow
                  </MainButton>
                )}
              </div>
            </div>

            {/* Right Side - Cover Image */}
            <div className="w-full md:w-1/2 order-1 md:order-2 flex justify-end">
              <div className="sm:aspect-[578/433] w-full max-w-[578px] group relative">
                {/* SVG Badge - absolutely positioned on the left, negative offset */}
                {/* <div style={{position: 'absolute', left: '-68px', top: '40px', zIndex: 10}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="135" height="135" viewBox="0 0 66 66" fill="none" role="img" className="icon masthead-pro-badge fill-current">
                    <path fillRule="evenodd" clipRule="evenodd" d="M27.3 16.4001L27.8 18.1001L26.6 18.5001L25 13.5001L27.2 12.8001C27.8 12.6001 28.3 12.6001 28.7 12.8001C29.1 13.0001 29.4 13.3001 29.5 13.8001C29.8 14.7001 29.4 15.6001 28.3 15.9001L27.3 16.4001ZM28.5 14.3001C28.4 13.9001 28 13.7001 27.6 13.9001L26.6 14.2001L27 15.6001L28 15.3001C28.5 15.1001 28.7 14.7001 28.5 14.3001ZM32.3 15.2001V17.2001H31.1V12.0001H33.6C34.6 12.0001 35.4 12.5001 35.4 13.5001C35.4 14.1001 35.1 14.6001 34.5 14.8001C35 15.0001 35.3 15.2001 35.3 15.8001C35.3 16.0001 35.4 16.3001 35.4 16.5001C35.4 16.9001 35.5 17.1001 35.6 17.2001V17.3001H34.4C34.3 17.2001 34.3 17.0001 34.2 16.6001C34.2 16.5001 34.2 16.3001 34.2 16.1001C34.1 15.6001 33.9 15.3001 33.3 15.3001L32.3 15.2001ZM34.1 13.6001C34.1 13.2001 33.8 12.9001 33.3 12.9001H32.2V14.3001H33.3C33.9 14.3001 34.1 14.1001 34.1 13.6001ZM41.4 16.3001C40.9 17.8001 39.6 18.6001 38.1 18.1001C36.6 17.6001 36 16.2001 36.5 14.7001C37 13.2001 38.3 12.4001 39.8 12.9001C41.2 13.4001 41.8 14.8001 41.4 16.3001ZM39.4 13.8001C38.5 13.5001 37.9 14.1001 37.6 15.1001C37.3 16.0001 37.5 16.9001 38.4 17.2001C39.3 17.5001 39.9 16.9001 40.2 16.0001C40.5 14.9001 40.3 14.1001 39.4 13.8001Z" fill="currentColor"></path>
                  </svg>
                </div> */}
                {/* {auth?.user && (
                  <div className="hidden group-hover:block absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="flex items-center justify-center bg-white size-[30px] xl:size-[60px] rounded-full z-10">
                      <input
                        type="file"
                        accept={getAcceptAttribute("image")}
                        onChange={handleFileInputChange}
                        id="imageslist"
                        className="cursor-pointer hidden"
                      />
                      <label
                        role="button"
                        htmlFor="imageslist"
                        className="flex items-center justify-center bg-transparent size-fit xl:mt-1"
                      >
                        <Title text={"Edit"} width={"50"}>
                          <i className="fi fi-rs-pen-circle text-[12px] xl:text-[24px] text-mediumgray hover:text-primaryblue"></i>
                        </Title>
                      </label>
                    </div>
                  </div>
                )} */}
                {selectedFile ? (
                  <div className="relative w-full h-full">
                    <img
                      src={imagePreview || URL.createObjectURL(selectedFile)}
                      className="w-full h-full object-cover rounded-3xl"
                      alt="tradesposter"
                    />
                    {auth?.user && (
                      <div className="absolute inset-0 bg-black opacity-0 hover:opacity-35 transition-opacity duration-300 rounded-3xl" />
                    )}
                  </div>
                ) : (
                  <div className="relative sm:aspect-[578/433] w-full max-w-[578px] rounded-xl overflow-visible">
                    {/* Main large image */}
                    <div className="relative w-full h-full rounded-xl overflow-hidden">
                      <img
                        src="https://tradeposter.blob.core.windows.net/tradeposter/images/TradesPoster-banner-2---FULL-QUALITY-1747311998804.jpg"
                        className="w-full h-full object-cover"
                        alt="tradesposter main"
                      />
                    </div>
                    
                    {/* Overlay images */}
                    {/* Large overlay extending left */}
                    <div className="absolute -left-[44%] top-[10%] w-[280px] h-[200px] rounded-xl overflow-hidden shadow-lg z-10">
                      <img
                        src={require("../../assets/img/P5.jpeg")}
                        className="w-full h-full object-cover"
                        alt="tradesposter overlay 1"
                      />
                    </div>
                    
                    {/* Medium overlay top right */}
                    <div className="absolute -left-[57%] top-[63%] w-[220px] h-[160px] rounded-xl overflow-hidden shadow-lg z-20">
                      <img
                        src="https://tradeposter.blob.core.windows.net/tradeposter/images/marian-florinel-condruz-C-oYJoIfgCs-unsplash-1750089566203.jpg"
                        className="w-full h-full object-cover"
                        alt="tradesposter overlay 2"
                      />
                    </div>
                    
                    {/* Small overlay bottom right */}
                    <div className="absolute -left-[14%] -bottom-10 w-[180px] h-[140px] rounded-xl overflow-hidden shadow-lg z-30">
                      <img
                        src="https://tradeposter.blob.core.windows.net/tradeposter/images/gabriel-alenius-cPDTVCsbxcg-unsplash-1751902617041.jpg"
                        className="w-full h-full object-cover"
                        alt="tradesposter overlay 3"
                      />
                    </div>

                    {/* {auth?.user && (
                      <div className="absolute inset-0 bg-black opacity-0 hover:opacity-35 transition-opacity duration-300" />
                    )} */}
                  </div>
                )}
              </div>
            </div>
          </div>


          {/* Tabs Section */}
          <div ref={reviewsSectionRef} className="mt-10">
            <Tabs
              tabs={["Posts", "Portfolio", "Reviews", "About"]}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            >
              {/* Posts Tab */}
              <div>
                <UserGigs grid={true} />
              </div>
              {/* Portfolio Tab */}
              <div>
                <Portfolios />
              </div>
              {/* Reviews Tab */}
              <div className="tp-container-narrow mx-auto w-full">
                {/* Bigger review stats card at the top */}
                <div className="w-full flex justify-center">
                  <div className="rounded-xl max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full bg-white">
                    <PosterRanking 
                      ref={posterRankingRef}
                      show={true} 
                      onFilterChange={setStarFilter}
                      activeFilter={starFilter}
                      isOwnProfile={auth?.user != null && userIdFromUrl != null && String(auth.user?.id) === userIdFromUrl}
                      isCustomer={auth?.user?.roleType?.toLowerCase() === 'customer'}
                      onReviewClick={() => setSignIn(true)}
                      onShareReviewClick={handleShareReviewClick}
                    />
                  </div>
                </div>
                {/* Reviews list */}
                <div
                  className={`w-full flex justify-center ${PUBLIC_PROFILE_REVIEW_STATS_TO_LIST_CLASS}`}
                >
                  <div className="rounded-[0.75rem] max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full w-full">
                    <PosterReviews
                      showMeReply={true}
                      showMeReport={false}
                      DropdownClasses={"bg-white"}
                      starFilter={starFilter}
                      onClearFilter={() => setStarFilter(null)}
                    />
                  </div>
                </div>
              </div>
              {/* About Tab */}
              <div className="w-full">
                <div className="flex gap-[6.875rem] tp-container-medium mx-auto">
                  {/* Left Column */}
                  <div className="flex-1">
                    <Biography userData={userData} />
                    <Specialities userData={userData} />
                    <ServiceAreas userData={userData} />
                    <Keywords userData={userData} />
                    {/* Separator */}
                    <div className="h-px w-full bg-mediumgray my-8" />
                    {/* Stats */}
                    <ProfileStats 
                      userData={userData} 
                      onKeywordsClick={() => setKeywordsPopupOpen(true)}
                    />
                  </div>

                  {/* Right Column */}
                  <div className="w-[348px] flex flex-col gap-6">
                    {/* Business Info Section */}
                    <div>
                      <BusinessInfo userData={userData} />
                    </div>
                    
                    {/* Compliance Section (formerly Badges) */}
                    <div>
                      <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
                        Compliance
                      </SecondaryHeading>
                      <Badges />
                    </div>

                    {/* Membership Section (formerly Associations) */}
                    <div>
                      <Associations />
                    </div>
                    
                    {/* Business Contact Section - Hidden for basic plan users */}
                    {userData?.userPlan?.plan?.name?.toLowerCase() !== 'basic' && (
                      <div>
                        <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
                          Business Contact
                        </SecondaryHeading>
                        <BusinessContact />
                      </div>
                    )}
                    
                    {/* Business Hours Section */}
                    <div>
                      <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
                        Business Hours
                      </SecondaryHeading>
                      <TradingHours />
                    </div>
                    
                    {/* Social Media Section - Hidden for basic plan users */}
                    {userData?.userPlan?.plan?.name?.toLowerCase() !== 'basic' && (
                      <div>
                        <Social />
                      </div>
                    )}
                    
                    {/* Payment Methods Section */}
                    <div>
                       <Payment />
                    </div>

                  </div>
                </div>
                {/* <div className="w-screen mt-10 relative left-1/2 right-1/2 -translate-x-1/2">
                  <FullLengthSlider />
                </div> */}
              </div>
            </Tabs>
          </div>
        </div>
      </>
    );
  };
export default ProfileMainContainer;
